"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.seal");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _appBasicSetup = require("@/api/appBasicSetup");
var _editorForVue = require("@wangeditor/editor-for-vue");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Editor: _editorForVue.Editor,
    Toolbar: _editorForVue.Toolbar
  },
  data: function data() {
    return {
      dialogVisible: false,
      conditionType: {},
      // 条件
      ruleForm: {
        text: ''
      },
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: function () {
              var _customUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, insertFn) {
                var pictureUrl, _t;
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      _context.n = 1;
                      return (0, _ossUpload.uploadOSS)(file);
                    case 1:
                      pictureUrl = _context.v;
                      insertFn(pictureUrl);
                      _context.n = 3;
                      break;
                    case 2:
                      _context.p = 2;
                      _t = _context.v;
                      console.log('error ->', _t);
                    case 3:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 2]]);
              }));
              function customUpload(_x, _x2) {
                return _customUpload.apply(this, arguments);
              }
              return customUpload;
            }()
          }
        }
      },
      mode: 'default',
      // or 'simple'
      EditorOpen: false
    };
  },
  methods: {
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor);
      // 一定要用 Object.seal() ，否则会报错
    },
    open: function open(data) {
      this.conditionType = data;
      this.EditorOpen = true;
      this.ruleForm.text = data.text;
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.ruleForm = {
        text: ''
      };
      this.dialogVisible = false;
      this.EditorOpen = false;
    },
    submitForm: function submitForm() {
      var _this = this;
      this.$confirm('确认是否修改内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var obj = {};
        obj[_this.conditionType.key] = _this.ruleForm.text;
        (0, _appBasicSetup.editLicenseAndPrivacy)(obj).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '保存成功！'
            });
            _this.onClose();
          }
        });
      });
    },
    resetForm: function resetForm() {
      this.ruleForm.text = '';
    }
  }
};